import { Box, Theme, withStyles } from '@material-ui/core';

export const TitleBox = withStyles(({ spacing }: Theme) => ({
  root: {
    marginBottom: spacing(4),
  },
}))(Box);

export default {
  TitleBox,
};
